import React from 'react';
import { Formik, Form } from 'formik';
import TextInput from '@elements/fields/textInput';
import Button from '@elements/button';
import PhoneField from '../components/PhoneField';
import SocialLogin from '@modules/auth/socialLogin';
import { useGuestForm } from './useGuestForm';

interface GuestFormProps {
    onSwitchView: (view: string) => void;
    onClose: () => void;
}

const GuestForm: React.FC<GuestFormProps> = ({ onSwitchView, onClose }) => {
    const { guestValues, GuestSchema, handleGuestLogin, isSubmitting, countries, t, locale, isRequired, isDisablePhoneField } = useGuestForm(onSwitchView, onClose);

    return (
        <div className="w-full mt-14">
            <Formik
                initialValues={guestValues}
                validationSchema={GuestSchema}
                onSubmit={(values, actions) => {
                    handleGuestLogin(values, actions);
                }}
            >
                {({ isValid, dirty, handleBlur, handleChange, values, errors, touched, setFieldValue, setFieldTouched }) => (
                    <Form className="flex flex-col max-w-[320px] w-full m-auto form">
                        <div className="w-full mb-6">
                            <TextInput
                                error={errors.name && touched.name ? errors.name : ''}
                                value={values.name}
                                name="name"
                                label={t("client_general_name")}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </div>
                        <div className="w-full mb-6">
                            <TextInput
                                error={errors.email && touched.email ? errors.email : ''}
                                value={values.email}
                                name="email"
                                label={t("client_general_email")}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </div>
                        {isDisablePhoneField ? null : <div className="w-full mb-6">
                            <PhoneField
                                countryCode={values.countryCode}
                                phoneNumber={values.phoneNumber}
                                countryList={countries}
                                setFieldValue={setFieldValue}
                                setFieldTouched={setFieldTouched}
                                errors={errors}
                                touched={touched}
                                handleBlur={handleBlur}
                                isRequired={isRequired}
                            />
                        </div>}
                        <Button
                            className="h-12 shadow-md font-extrabold text-base mb-2 rounded-full"
                            size="slim"
                            type="submit"
                            theme="blue"
                            isDisabled={isSubmitting || !isValid || !dirty}
                            loading={isSubmitting}
                        >
                            {t("client_buttons_continueasguest")}
                        </Button>
                        <div className="w-full mb-3 mt-2">
                            <p className="text-center text-[#808080] text-sm mb-3">{t("client_general_or")}</p>
                            <SocialLogin action="guest" />
                        </div>
                        <div className="w-full mb-2" dir={locale?.includes("ar-") ? "rtl" : "ltr"}>
                            <span className="text-[#999] font-normal text-sm"> {t("w-alreadyHaveAnAccount")}</span>
                            <button
                                onClick={() => onSwitchView('login')}
                                className="text-[#008AF6] font-normal text-xs px-1"
                            >
                                {t("client_buttons_login")}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default GuestForm;
